<template>
  <div
    class="patient-filter"
    :class="$route.path !== '/dashboard' ? 'sidebar-page-patient-filter' : ''"
  >
    <span class="filter-label">{{ $t('text.filter') }}</span>
    <div class="selector organisation-filter">
      <el-select
        v-model="filter.organisationId"
        :placeholder="$t('text.select')"
        :size="$root.screenWidth >= 550 ? 'medium' : 'mini'"
        disabled
      >
        <el-option
          v-for="organisation in organisations"
          :key="organisation.OrganisationName.OrganisationId"
          :label="organisation.OrganisationName.Name"
          :value="organisation.OrganisationName.OrganisationId"
        >
        </el-option>
      </el-select>
    </div>
    <div class="selector">
      <el-select
        v-model="filter.buildingId"
        :placeholder="$t('text.show_all_facilities')"
        :size="$root.screenWidth >= 550 ? 'medium' : 'mini'"
      >
        <el-option
          v-for="building in buildings"
          :key="building.BuildingId"
          :label="building.BuildingName"
          :value="building.BuildingId"
        >
        </el-option>
      </el-select>
    </div>
    <div class="selector">
      <el-select
        v-if="!filter.buildingId"
        v-model="allAreas"
        :placeholder="$t('text.select')"
        :no-data-text="$t('text.please_select_facility_first')"
        :key="Math.random()"
        :size="$root.screenWidth >= 550 ? 'medium' : 'mini'"
      >
      </el-select>
      <el-select
        class="area-select"
        ref="areaSelect"
        v-else
        v-model="filter.filterIds"
        multiple
        :placeholder="$t('text.show_all_areas')"
        :loading="fetchAreasLoading"
        popper-class="area-operation-box"
        @change="handleFilterChange"
        :style="{ width: areaSelectorWidth + 'px' }"
        :size="$root.screenWidth >= 550 ? 'medium' : 'mini'"
      >
        <el-option-group
          v-for="group in filters"
          :key="group.label"
          :label="group.label"
        >
          <div
            v-for="item in group.options"
            :key="item.label"
            class="option-li"
          >
            <el-option
              class="option-item"
              v-if="item.type !== 'action'"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
            <li
              v-else
              class="el-select-dropdown__item action-item"
              @click="item.value"
            >
              <span>{{ item.label }}</span>
            </li>
            <i class="el-icon-arrow-right" v-if="item.type === 'action'"></i>
          </div>
        </el-option-group>
      </el-select>
    </div>
    <div class="selector" v-if="showPatientBox">
      <PatientInput />
    </div>
    <AddArea ref="addArea" />
    <ManageArea ref="manageArea" />
  </div>
</template>

<script>
import AddArea from '@/components/dashboard/AddArea'
import ManageArea from '@/components/dashboard/ManageArea'
import PatientInput from '@/components/patients/PatientInput.vue'
import { filterFlag } from '@/const'
import _ from 'lodash'
export default {
  data() {
    return {
      organisations: this.$store.getters[`user/userOwnedOrganisations`],
      buildings: this.initBuildings(),
      fetchAreasLoading: false,
      filter: this.$store.state.filter.dashboardFilter,
      allAreas: this.$t('text.show_all_areas'),
      areaSelectorWidth: 177
    }
  },
  props: {
    showPatientBox: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  computed: {
    filters() {
      if (!this.filter.buildingId) return []
      let filters = [
        {
          label: this.$t('text.areas'),
          value: filterFlag.area,
          options: []
        },
        {
          label: this.$t('text.floors'),
          value: filterFlag.floor,
          options: []
        }
      ]
      filters[0].options = this.$store.state.filter.areaFilters.map(area => {
        return {
          label: area.Name,
          value: area.WardId,
          type: 'option'
        }
      })
      filters[0].options = filters[0].options.concat([
        {
          label: this.$t('text.new_area'),
          value: this.addArea,
          type: 'action'
        },
        {
          label: this.$t('text.manage_areas'),
          value: this.manageArea,
          type: 'action'
        }
      ])

      // get floors
      let selectedBuilding = this.buildings.filter(
        building =>
          building.BuildingId ===
          this.$store.state.filter.dashboardFilter.buildingId
      )
      if (selectedBuilding.length && selectedBuilding[0].Floors) {
        filters[1].options = selectedBuilding[0].Floors.map(floor => {
          return {
            label: floor.FloorName,
            value: floor.FloorId,
            type: 'option'
          }
        })
      }
      return filters
    }
  },
  components: {
    AddArea,
    ManageArea,
    PatientInput
  },
  mounted() {
    if (!this.filter.organisationId) {
      this.filter.organisationId = this.$store.getters[
        `user/selecteOrganisationId`
      ]
    }
    this.getBuildings()
    this.getAreas()
    this.calcAreaSelectorWidth()
  },
  watch: {
    filter: {
      handler: _.debounce(function() {
        this.saveFilter()
      }),
      deep: true
    },
    'filter.buildingId'(val, oldVal) {
      if (oldVal) {
        this.filter.filterIds = []
      }
      this.getAreas()
    },
    'filter.filterIds'() {
      this.getFilterType()
    }
  },
  methods: {
    initBuildings() {
      return [
        {
          BuildingId: '',
          BuildingName: this.$t('text.show_all_facilities')
        }
      ]
    },
    getBuildings() {
      this.$store.dispatch('filter/getBuildings').then(() => {
        let initBuildings = this.initBuildings()
        this.buildings = initBuildings.concat(
          this.$store.state.filter.buildings
        )
      })
    },
    getAreas() {
      if (!this.filter.buildingId) return
      this.fetchAreasLoading = true
      this.$store
        .dispatch('filter/getAreaFilters')
        .then(() => {
          this.fetchAreasLoading = false
        })
        .catch(() => {
          this.fetchAreasLoading = false
        })
    },
    handleFilterChange() {
      this.calcAreaSelectorWidth()
      if (this.filter.filterIds.length > 1) {
        let existGroup
        let currentGroup
        this.filters.forEach(group => {
          group.options.forEach(option => {
            if (option.value === this.filter.filterIds[0]) {
              existGroup = group.label
            }
            if (
              option.value ===
              this.filter.filterIds[this.filter.filterIds.length - 1]
            ) {
              currentGroup = group.label
            }
          })
        })
        if (currentGroup !== existGroup) {
          this.showErrorMsg(this.$t('text.select_area_warning'))
          this.filter.filterIds.pop()
        }
      }
    },
    getFilterType() {
      if (this.filter.filterIds.length <= 0) {
        this.filter.flag = filterFlag.all
      } else {
        this.filters.forEach(group => {
          group.options.forEach(option => {
            if (option.value === this.filter.filterIds[0]) {
              this.filter.flag = group.value
            }
          })
        })
      }
    },
    calcAreaSelectorWidth() {
      let actualLength = this.filter.filterIds.length * 110 + 30
      this.areaSelectorWidth = actualLength <= 177 ? 177 : actualLength
    },
    showErrorMsg(msg) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${msg}</div>` +
          `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.ok').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      )
    },
    addArea() {
      this.$refs.addArea.openDialog()
      this.$refs.areaSelect.blur()
    },
    manageArea() {
      this.$refs.manageArea.openDialog()
      this.$refs.areaSelect.blur()
    },
    saveFilter() {
      this.$store.dispatch('filter/saveUserFilter', this.filter)
    }
  }
}
</script>
